/*! jQuery 4.0 Compatibility Polyfill - Restores removed APIs for legacy plugins (Slick, Fancybox, etc.) */
(function($) {
  if (!$) return;

  var class2type = {};
  "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ").forEach(function(name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });

  if (!$.type) {
    $.type = function(obj) {
      if (obj == null) return obj + "";
      return typeof obj === "object" || typeof obj === "function"
        ? class2type[Object.prototype.toString.call(obj)] || "object"
        : typeof obj;
    };
  }

  if (!$.isFunction) {
    $.isFunction = function(obj) {
      return typeof obj === "function";
    };
  }

  if (!$.isArray) {
    $.isArray = Array.isArray;
  }

  if (!$.isWindow) {
    $.isWindow = function(obj) {
      return obj != null && obj === obj.window;
    };
  }

  if (!$.isNumeric) {
    $.isNumeric = function(obj) {
      var type = typeof obj;
      return (type === "number" || type === "string") && !isNaN(obj - parseFloat(obj));
    };
  }

  if (!$.camelCase) {
    $.camelCase = function(string) {
      return string.replace(/^-ms-/, "ms-").replace(/-([a-z])/g, function(all, letter) {
        return letter.toUpperCase();
      });
    };
  }

  if (!$.now) {
    $.now = Date.now;
  }

  if (!$.trim) {
    $.trim = function(text) {
      return text == null ? "" : (text + "").trim();
    };
  }

  if (!$.nodeName) {
    $.nodeName = function(elem, name) {
      return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    };
  }

  if (!$.proxy) {
    $.proxy = function(fn, context) {
      if (typeof context === "string") {
        var tmp = fn[context];
        context = fn;
        fn = tmp;
      }
      if (typeof fn !== "function") return undefined;
      var args = Array.prototype.slice.call(arguments, 2);
      var proxy = function() {
        return fn.apply(context || this, args.concat(Array.prototype.slice.call(arguments)));
      };
      proxy.guid = fn.guid = fn.guid || $.guid++;
      return proxy;
    };
  }

  if (!$.parseJSON) {
    $.parseJSON = JSON.parse;
  }

  if (!$.globalEval) {
    $.globalEval = function(code) {
      var script = document.createElement("script");
      script.text = code;
      document.head.appendChild(script).parentNode.removeChild(script);
    };
  }

  if (!$.fn.bind) {
    $.fn.bind = function(types, data, fn) {
      return this.on(types, null, data, fn);
    };
  }

  if (!$.fn.unbind) {
    $.fn.unbind = function(types, fn) {
      return this.off(types, null, fn);
    };
  }

  if (!$.fn.delegate) {
    $.fn.delegate = function(selector, types, data, fn) {
      return this.on(types, selector, data, fn);
    };
  }

  if (!$.fn.undelegate) {
    $.fn.undelegate = function(selector, types, fn) {
      return arguments.length === 1
        ? this.off(selector, "**")
        : this.off(types, selector || "**", fn);
    };
  }

  if (!$.fn.andSelf) {
    $.fn.andSelf = $.fn.addBack;
  }

  if (!$.fn.size) {
    $.fn.size = function() {
      return this.length;
    };
  }

  if ($.expr && $.expr.pseudos && !$.expr.filters) {
    $.expr.filters = $.expr.pseudos;
  }

  if (!$.htmlPrefilter) {
    $.htmlPrefilter = function(html) {
      return html;
    };
  }

  if (!$.cssNumber) {
    $.cssNumber = {};
  }

  if (!$.fn.load && $.fn.on) {
    var _load = $.fn.load;
    $.fn.load = function(url, params, callback) {
      if (typeof url !== "string" && _load) {
        return _load.apply(this, arguments);
      }
      return this;
    };
  }
})(window.jQuery);
